module.exports = __webpack_public_path__ + "summernote.eot";


//////////////////
// WEBPACK FOOTER
// ./~/summernote/dist/font/summernote.eot
// module id = 1196
// module chunks = 6